import { c as _c } from "react/compiler-runtime";
import { useTheme } from '../../utils/useTheme';
import { type PromoBannerProps } from './types';
import { LinkIcon } from '../icons/LinkIcon';
import { usePromoBannerSize } from './hooks';
import Button from '../Button';
import Typography from '../Typography';
import Chip from '../Chip';
import { StyledPromoBannerContainer, StyledTagContainer, StyledContentContainer, StyledHeadline, StyledContentText, StyledButtonsContainer, StyledLearnMoreButtonWrapper, StyledDismissButtonWrapper, StyledImageContainer, StyledImage } from './styles';
const PromoBanner = props => {
  const $ = _c(29);
  const theme = useTheme();
  const {
    ref,
    isSmall
  } = usePromoBannerSize();
  const backgroundGradient = `linear-gradient(135deg, ${theme.tokens.background.semantic.info.tonal.superSoft.default} 0%, ${theme.tokens.background.semantic.success.tonal.superSoft.default} 100%)`;
  const buttonDirection = isSmall ? "column" : "row";
  const buttonsFullWidth = isSmall;
  let t0;
  if ($[0] !== props.tag) {
    t0 = props.tag != null && props.tag !== "" && <StyledTagContainer><Chip label={props.tag} variant="semantic-info" /></StyledTagContainer>;
    $[0] = props.tag;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.headline) {
    t1 = <StyledHeadline><Typography variant="h3">{props.headline}</Typography></StyledHeadline>;
    $[2] = props.headline;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.content) {
    t2 = props.content != null && <StyledContentText><Typography variant="body1">{props.content}</Typography></StyledContentText>;
    $[4] = props.content;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== buttonDirection || $[7] !== buttonsFullWidth || $[8] !== props.dismissButton || $[9] !== props.learnMoreButton) {
    t3 = (props.learnMoreButton != null || props.dismissButton != null) && <StyledButtonsContainer buttonDirection={buttonDirection} buttonsFullWidth={buttonsFullWidth}>{props.learnMoreButton != null && <StyledLearnMoreButtonWrapper buttonsFullWidth={buttonsFullWidth}><Button rightIcon={<LinkIcon />} variant="filled" {...props.learnMoreButton} /></StyledLearnMoreButtonWrapper>}{props.dismissButton != null && <StyledDismissButtonWrapper buttonsFullWidth={buttonsFullWidth}><Button variant="text" {...props.dismissButton} /></StyledDismissButtonWrapper>}</StyledButtonsContainer>;
    $[6] = buttonDirection;
    $[7] = buttonsFullWidth;
    $[8] = props.dismissButton;
    $[9] = props.learnMoreButton;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== isSmall || $[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = <StyledContentContainer isSmall={isSmall}>{t1}{t2}{t3}</StyledContentContainer>;
    $[11] = isSmall;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== props.headline || $[17] !== props.image || $[18] !== props.imageAlt) {
    t5 = typeof props.image === "string" ? <StyledImage src={props.image} alt={props.imageAlt ?? props.headline} /> : props.image;
    $[16] = props.headline;
    $[17] = props.image;
    $[18] = props.imageAlt;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== isSmall || $[21] !== t5) {
    t6 = <StyledImageContainer isSmall={isSmall}>{t5}</StyledImageContainer>;
    $[20] = isSmall;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== backgroundGradient || $[24] !== ref || $[25] !== t0 || $[26] !== t4 || $[27] !== t6) {
    t7 = <StyledPromoBannerContainer ref={ref} backgroundGradient={backgroundGradient}>{t0}{t4}{t6}</StyledPromoBannerContainer>;
    $[23] = backgroundGradient;
    $[24] = ref;
    $[25] = t0;
    $[26] = t4;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
};
export default PromoBanner;
export { PromoBanner };
export type { PromoBannerProps } from './types';